import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="container-site">
        <div className="footer-grid">
          {/* Brand Column */}
          <div className="footer-brand">
            <Link to="/" className="logo" style={{ color: 'white' }}>
              Esy<span>Prints</span>
            </Link>
            <p>
              India&apos;s hyper-local on-demand print marketplace. Design, order, and get
              professionally printed products delivered to your doorstep in hours by local
              printers near you.
            </p>
            <div className="footer-social">
              {/* TODO: replace these /help fallbacks with real social URLs once
                  the marketing accounts are live. Using target="_blank" with
                  noopener so we're spec-correct in case the hrefs are
                  swapped to external links inline. */}
              <a href="/help" target="_blank" rel="noopener" aria-label="Facebook">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" stroke="none">
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
                </svg>
              </a>
              <a href="/help" target="_blank" rel="noopener" aria-label="Twitter">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" stroke="none">
                  <path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z"/>
                </svg>
              </a>
              <a href="/help" target="_blank" rel="noopener" aria-label="Instagram">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="2" width="20" height="20" rx="5"/>
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>
                </svg>
              </a>
              <a href="/help" target="_blank" rel="noopener" aria-label="LinkedIn">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" stroke="none">
                  <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/>
                  <rect x="2" y="9" width="4" height="12"/>
                  <circle cx="4" cy="4" r="2"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Let Us Help */}
          <div className="footer-col">
            <h4>Let Us Help</h4>
            <ul>
              <li><Link to="/account">My Account</Link></li>
              <li><Link to="/orders">My Orders</Link></li>
              <li><Link to="/help">Contact Us</Link></li>
              <li><Link to="/categories">Bulk Orders</Link></li>
            </ul>
          </div>

          {/* Our Company */}
          {/* TODO: link to dedicated marketing pages once /about, /careers,
              /blog, /partners are built. Falling back to /help in the meantime
              so users land on a real page rather than a no-op anchor. */}
          <div className="footer-col">
            <h4>Our Company</h4>
            <ul>
              <li><Link to="/help">About EsyPrints</Link></li>
              <li><Link to="/help">Careers</Link></li>
              <li><Link to="/help">Blog</Link></li>
              <li><Link to="/help">Partner with Us</Link></li>
            </ul>
          </div>

          {/* Our Policies */}
          <div className="footer-col">
            <h4>Our Policies</h4>
            <ul>
              <li><Link to="/terms">Terms &amp; Conditions</Link></li>
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><Link to="/help">Returns &amp; Refunds</Link></li>
              <li><Link to="/help">Shipping Policy</Link></li>
            </ul>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <span>&copy; {new Date().getFullYear()} EsyPrints. All rights reserved.</span>
          <div className="payment-icons">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="28" viewBox="0 0 48 28" fill="none">
              <rect width="48" height="28" rx="4" fill="rgba(255,255,255,0.15)"/>
              <text x="24" y="18" textAnchor="middle" fill="rgba(255,255,255,0.6)" fontSize="10" fontFamily="sans-serif" fontWeight="700">VISA</text>
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="28" viewBox="0 0 48 28" fill="none">
              <rect width="48" height="28" rx="4" fill="rgba(255,255,255,0.15)"/>
              <circle cx="20" cy="14" r="8" fill="rgba(255,100,50,0.4)"/>
              <circle cx="28" cy="14" r="8" fill="rgba(255,200,0,0.4)"/>
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="28" viewBox="0 0 48 28" fill="none">
              <rect width="48" height="28" rx="4" fill="rgba(255,255,255,0.15)"/>
              <text x="24" y="18" textAnchor="middle" fill="rgba(255,255,255,0.6)" fontSize="10" fontFamily="sans-serif" fontWeight="700">UPI</text>
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="28" viewBox="0 0 48 28" fill="none">
              <rect width="48" height="28" rx="4" fill="rgba(255,255,255,0.15)"/>
              <text x="24" y="18" textAnchor="middle" fill="rgba(255,255,255,0.6)" fontSize="9" fontFamily="sans-serif" fontWeight="700">RuPay</text>
            </svg>
          </div>
        </div>
      </div>
    </footer>
  );
}
